import type { FaireProductEntity } from "../../entity_types/product";

export const p_j29gzkwfeh: FaireProductEntity = {
  token: "p_j29gzkwfeh",
  type: "product",
  name: "Cubic Zirconia Dangle Floral Necklace",
  brandToken: "b_99ch5ye698",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/baaaac984f300cc8f4e5ac8868ea54997b2988cbe303fea366e0cc1dbebeedf6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3bb456c0b4b8f3a932aa4d387c438042586d780d9ebb190f90072665130913e5.jpeg",
    "https://cdn.faire.com/fastly/cc4d6e3e20430397d36b9b49393f3ea815bef343b0f444acb73afe2c2a840c81.jpeg",
    "https://cdn.faire.com/fastly/4834d98d447f070723311e73ea17f25d89f1cc922d607dcc51379c2784841acd.jpeg",
    "https://cdn.faire.com/fastly/8824a9235a75566483db61b77e3fe9d1d2c678dbbc46a256da752aa4822d399a.jpeg",
    "https://cdn.faire.com/fastly/699347c75ccb8fba84bbb9774432ba5a9669b969bee00e083087ce570a14ad18.jpeg",
    "https://cdn.faire.com/fastly/cf4cf77e57fd5c85b8fb20e10e94a126f8dd7d92e8b308d8bbc1a2c7e88262be.jpeg",
    "https://cdn.faire.com/fastly/53c18ba481b6c7e2bb66eebb839e4da70e6d233ad2ec021a418640901656c2cd.jpeg",
    "https://cdn.faire.com/fastly/c7694bc2be3422181504be91af2ce92ed234697fdc27e0936e5ce6fe48562f0c.jpeg",
    "https://cdn.faire.com/fastly/8d4b542cd6e17cd73ca8b99b04dc98041ba5a8f3404e18d2c6cd9513f92bf73f.jpeg",
    "https://cdn.faire.com/fastly/04b309ba117f7260b08ad5545b3cdb4b791d102d16cb4e0a668737f7022cda46.jpeg",
    "https://cdn.faire.com/fastly/4a73066e95303dc012c3e781b54ec4c679f95987c2139098d787eb6385cc8f5a.jpeg",
  ],
  priceDollars: 29.1,
  description:
    'Discover how effortless style meets lasting quality with our 18K Gold PVD Stainless Steel Dangle Floral Necklace, designed to bring graceful movement and everyday shine to your jewelry collection. Crafted from durable 316L stainless steel and finished in radiant 18K gold PVD, this necklace delivers tarnish-resistant brilliance made for daily wear. The delicate floral dangle design creates soft dimension and subtle sparkle at the neckline, offering a feminine statement that transitions seamlessly from casual daytime looks to polished evening styling. Lightweight and comfortable, this timeless piece remains luminous wear after wear.\n\n• Lightweight & perfect for all day wear\n• Waterproof, non-tarnish, hypoallergenic\n• Premium 18K Gold PVD over 316L surgical-grade stainless steel\n\nWhy PVD?\nWe use Physical Vapor Deposition (PVD) to coat 18K Gold over 316L stainless steel. This process ensures a high-quality, non-tarnish finish that resists wear & will never turn skin green—ideal for jewelry to be worn every day.\n\nSize/Dimensions: 18" + 2" extender\nSize/Dimensions (Charm): 13.20mm x 19.90mm (0.51" x 0.78")\nWeight: 4.83g\n\nSame day shipping from Destin, FL before 3PM CST.',
  tags: [],
  msrpDollars: 58.2,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:51.481Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
